import React from 'react'
import { Tag } from '@surecompanies/core_components'
import { ApiOutlined, PhoneOutlined } from '@ant-design/icons'
import { BotType } from '../../../../api/dto/get-payment-bot-dashboard.dto'

const BOT_TYPE_META: Record<
  string,
  { label: string; color: string; icon: React.ReactNode }
> = {
  [BotType.WEB_AGENT]: {
    label: 'WEB AGENT',
    color: 'purple',
    icon: <ApiOutlined />,
  },
  [BotType.IVR]: { label: 'IVR', color: 'blue', icon: <PhoneOutlined /> },
}

interface Props {
  botType: BotType | null
  /** When set, renders as a KPI badge ("10 WEB AGENT"). */
  count?: number
}

// botType arrives as `string | null` from the API — fall back to a plain tag for
// any value not in the known set (covers null and future bot types). The
// optional count turns the tag into a KPI badge ("10 WEB AGENT") so the KPI
// card and the table's Type column share one rendering.
export function BotTypeTag({ botType, count }: Props) {
  const meta = botType ? BOT_TYPE_META[botType] : undefined
  const prefix = count === undefined ? '' : `${count} `
  if (!meta) {
    return (
      <Tag style={{ margin: 0 }}>
        {prefix}
        {botType ?? '—'}
      </Tag>
    )
  }
  return (
    <Tag icon={meta.icon} color={meta.color} style={{ margin: 0 }}>
      {prefix}
      {meta.label}
    </Tag>
  )
}
